export function getCsrfToken(): string {
  if (typeof document === 'undefined') return '';

  const pair = document.cookie
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith('ny_csrf='));

  return pair ? decodeURIComponent(pair.slice('ny_csrf='.length)) : '';
}

export function csrfHeader(): Record<string, string> {
  const token = getCsrfToken();
  return token ? { 'X-CSRF-Token': token } : {};
}
